import axios from "axios";
import url from "../urls";

export default {
  // 调用后端 /LLM/Chat 代理，api key 只存在于后端，前端不再暴露
  getDeepSeekResponse(context, data) {
    return new Promise((resolve, reject) => {
      const { url: customUrl, temprature, ...payload } = data || {};
      const postUrl = customUrl || url.LLMChatUrl;
      // 纠正历史拼写：temprature -> temperature
      if (temprature !== undefined) {
        payload.temperature = temprature;
      }
      axios
        .post(postUrl, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
};
